import React from 'react';
import { GreetingColors } from '../../Colors';
import TimeContainer from '../../TimeContainer';
import SwipeableFlows from '../bigPicture/SwipeableFlows';
import SwipeableFlowsContainer from '../bigPicture/SwipeableFlowsContainer';
import styles from './week-reflection.module.css';

export const FlowDetails = ({ close, flows }) => {
    let timeOfDay = new TimeContainer().getTimeOfDay();
    const timeOfDayBGColor = GreetingColors[timeOfDay].background;

    return (
        <div className={styles.flowPopup} style={{ background: timeOfDayBGColor }}>
            <SwipeableFlowsContainer>
                <div className={styles.backToStoryButton} onClick={close}>
                    x
                </div>
                <SwipeableFlows
                    flows={flows}
                    swipeHintStyle={{ color: "white", fontSize: "12px", marginRight: "1rem" }}
                />
            </SwipeableFlowsContainer>
        </div>
    )
}